import React, { Component } from 'react';
import * as GlobalActions from '../../reducers/actions';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { S3HOST } from '../../ApiConstants';
import FormStyles from './FormStyles';
import LandingImages from '../LandingPageNew/LandingImages';
import view from '../../Enums';
import { NavLink } from 'react-router-dom';
import { Event } from '../LandingPageNew/Tracking/Track';

class Form3New extends Component {
  componentDidMount() {
    Event(
      'Partner Page form finish',
      'Partner page form finish viewed',
      '',
      ''
    );
  }

  getContent = key => {
    if (
      this.props &&
      this.props.globalData &&
      this.props.globalData.landing_translations &&
      this.props.viewMode
    ) {
      return this.props.globalData.landing_translations[key];
    }
    return null;
  };

  getUniversalContent = key => {
    if (
      this.props &&
      this.props.globalData &&
      this.props.globalData.landing_translations &&
      this.props.viewMode
    ) {
      if (key in this.props.globalData.universal_translations)
        return this.props.globalData.universal_translations[key];
    }
    return null;
  };

  getStyle = style_id => {
    if (style_id in FormStyles)
      return FormStyles[style_id][this.props.viewMode];
    console.log(style_id + ' style not initialized.');
    return {};
  };

  getImage = image_id => {
    if (image_id in LandingImages)
      return (
        S3HOST +
        '/' +
        this.props.globalData.universal_translations[
          LandingImages[image_id][this.props.viewMode]
        ]
      );
    console.log(image_id + ' image not initialized.');
    return {};
  };

  render() {
    let gc = this.props.getContent;
    let guc = this.props.getUniversalContent;
    let gs = this.props.getStyle;
    let gi = this.props.getImage;

    return (
      <React.Fragment>
        {this.props.globalData.form_translations && (
          <div
            style={{
              height: this.props.screenheight - 80 + 'px',
              overflowY:
                this.props.viewMode == view.MOBILE ? 'visible' : 'scroll'
            }}
          >
            {this.props.viewMode == view.DESKTOP && (
              <NavLink
                exact
                to={
                  this.props.globalData.locale
                    ? '/' + this.props.globalData.locale
                    : '/'
                }
                style={{ textDecoration: 'none', color: '#ffffff' }}
              >
                <img style={gs('form_oyo_icon')} src={gi('OYO_WHITE')} />
              </NavLink>
            )}

            <div style={gs('form3_content_container')}>
              <img
                style={gs('form3_success_icon')}
                src="/partnerpage/images/success_icon.png"
              ></img>
              <div style={gs('form3_content_body')}>
                <div style={gs('form3_content_heading')}>
                  {/*Thanks for considering us !*/}
                  {gc('formstep3_header')}
                </div>
                <div style={gs('form3_subcontent')}>
                  {gc('formstep3_content')}
                </div>
              </div>
              <NavLink
                onClick={() =>
                  Event(
                    'Partner Page form finish',
                    'Go back to landing page clicked',
                    '',
                    ''
                  )
                }
                exact
                to={
                  this.props.globalData.locale
                    ? '/' + this.props.globalData.locale
                    : '/'
                }
                style={{ textDecoration: 'none', color: '#ffffff' }}
              >
                <div class={'hoverColor'} style={gs('go_to_homepage_button')}>
                  <span style={gs('go_to_homepage_button_content')}>
                    {gc('formstep3_home')}
                  </span>
                </div>
              </NavLink>
            </div>
            {this.props.viewMode == view.DESKTOP && (
              <div style={gs('form3_footer')}>
                <span>
                  <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href={guc('email_us_link')}
                  >
                    <img
                      className={'hover'}
                      src={gi('form3_footer_mail_icon')}
                      style={gs('form3_footer_icon')}
                    />
                  </a>
                  <span style={gs('form3_footer_content')}>
                    {/*oyo.usa.partnerships@oyorooms.com*/}
                    {gc('form3_footer_mail')}
                  </span>
                </span>
                <span>
                  <a href={guc('call_us_link')}>
                    <img
                      className={'hover'}
                      src={gi('form3_footer_phone_icon')}
                      style={gs('form3_footer_icon')}
                    />
                  </a>
                  <span style={gs('form3_footer_content')}>
                    {gc('form3_footer_phone_number')}
                  </span>
                </span>
              </div>
            )}
          </div>
        )}
      </React.Fragment>
    );
  }
}

const mapDispatchToProps = dispatch => {
  return {
    globalActions: bindActionCreators(GlobalActions, dispatch)
  };
};

const mapStateToProps = state => {
  return {
    globalData: state.globalReducer
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Form3New);
